import React, { useState, useEffect } from "react";
import { useProjectProvider } from "../../../../Providers/Client/Project";
import JobsTable from "./JobsTable";
import ProjectCard from "./ProjectCard";
import OngoingJobInformation from "../Dashboard/OngoingJobInformation";
import { userPermissions } from "../../../../Utils/constants";
import { useSelector } from "react-redux";

export default function JobsHome({ setActive, setPostJob, setJobType, jobId, setJobId, projectId, setProjectId }) {
  const { projects, fetchProjects, hasAccessToDefaultProject } = useProjectProvider();
  const permissions  = useSelector((state) => state.user.permissions);
  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(()=>{
    if(!hasAccessToDefaultProject){
      setProjectId(projects[0].id)
    }
  },[hasAccessToDefaultProject])

  return jobId === null ? (
    <div className="flex flex-col lg:flex-row justify-between lg:space-x-8">
      <div className="lg:w-[43%] lg:max-w-[450px]">
        <span className="text-2xl">Projects</span>
        <div
          style={{
            backgroundColor: projects.length === 0 && "white",
            height: "100vh",
          }}
          className="flex md:flex-col mt-8 space-y-12 lg:mr-2 overflow-y-auto overflow-x-hidden h-[100vh] pb-2"
        >
          <div className="space-y-4">
            {
              hasAccessToDefaultProject ? 
                <ProjectCard
                  setProjectId={setProjectId}
                  project={{
                    id: undefined,
                    title: "Default Project",
                    createdAt: null,
                  }}
                  key=""
                />
              : null
            }
            {projects.map((project) => (
              <ProjectCard
                setProjectId={setProjectId}
                project={project}
                key={project.id}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col grow">
        <div className="flex lg:mt-0 mt-8 flex-row justify-between">
          <span className="text-2xl">Jobs</span>
          {
            permissions?.includes(`admin-client`) || permissions?.includes(userPermissions.job.add) ?
              <button
                onClick={() => {
                  setPostJob(true);
                  setJobType("Hourly/ Contract");
                }}
                className="text-white bg-[#2EBAA3] px-2 py-1 rounded-md shadow-md hover:animate-pulse"
              >
                Create
              </button>
            : null
          }
        </div>
        <div className="flex flex-1">
          <JobsTable
            setActive={setActive}
            setJobId={setJobId}
            projectId={projectId}
            setPostJob={setPostJob}
            setJobType={setJobType}
          />
        </div>
      </div>
    </div>
  ) : (
    <OngoingJobInformation jobId={jobId} reset={() => setJobId(null)} />
  );
}
